
<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h4>OnBoarding Detayı</h4>
      <v-row style="margin-top:100px;">
        <v-col cols="12" md="4">
          <h4>Resim <span style="color:red;">(296 × 269)</span></h4>
          <v-img
            style="cursor:pointer;"
            v-if="onBoardingData.imgUrl!='' && onBoardingData.imgUrl!=undefined"
            :src="onBoardingData.imgUrl"
            aspect-ratio="1.7"
            @click="redirectImagePath(onBoardingData.imgUrl)"
          ></v-img>
          <v-file-input
            show-size
            v-model="onBoardingData.img"
            @change="previewFiles"
            accept="image/*"
            label="Resim değiştir"
            required
          ></v-file-input>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Animasyon
            <v-icon
          style="font-size:17px;"
        v-if="!alert"
        color="#4d48f9"
        @click="alert = true"
      >
        info
      </v-icon>

    <v-alert
      v-model="alert"
      border="left"
      close-text="Close Alert"
      color="#4d48f9"
      dark
      dismissible
    >
Animasyonlar json formatında girilmelidir.
    </v-alert>
          </h4>
          <a v-if="onBoardingData.animationUrl!=null" :href="onBoardingData.animationUrl">{{onBoardingData.animationUrl.split('/')[4]}}</a>
          <v-file-input
            show-size
            v-model="onBoardingData.animation"
            accept="application/json"
            label="Animasyon değiştir"
            required
          ></v-file-input>
        </v-col>
        <v-col cols="12" md="8"></v-col>
        <v-col cols="12" md="4">
          <h4>Başlık</h4>
          <v-text-field
            v-model="onBoardingData.title"
            maxlength="255"
            counter="255"
            :rules="titleRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="12">
          <h4>Açıklama</h4>
          <v-textarea
            v-model="onBoardingData.description"
            :rules="descriptionRules"
            rows="1"
            auto-grow
            maxlength="255"
            counter="255"
            required
            name="input-7-1"
          ></v-textarea>
        </v-col>
        <v-col cols="12" md="4">
          <h4>Link</h4>
          <v-text-field v-model="onBoardingData.link" required></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Link Metni</h4>
          <v-text-field v-model="onBoardingData.linkText" required></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Sıralama</h4>
          <v-text-field
            v-model="onBoardingData.ordering"
            type="number"
            min="0"
            :rules="orderRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Aktif/Pasif</h4>
          <v-checkbox v-model="onBoardingData.active" color="#4d48f9"></v-checkbox>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="7">
          <v-btn
            depressed
            color="#4d48f9"
            style="text-transform: none !important;float:right;color:white;"
            @click="onBoardingUpdate()"
          >GÜNCELLE</v-btn>
        </v-col>
      </v-row>

        <v-dialog
                v-model="dialog"
                max-width="600"
        >
            <v-card>
                <v-card-title class="headline">Lütfen alanları kontrol edin</v-card-title>

                <v-card-text>
                    <ul>
                        <li v-for="errorList in this.errorList" :key="errorList">{{errorList}}</li>
                    </ul>
                </v-card-text>

            </v-card>
        </v-dialog>
      <!-- <v-row>
          
      </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "OnBoardingDetails",
  computed: mapGetters(["onBoardingData"]),
  methods: {
    ...mapActions(["getOnBoarding","updateOnBoarding"]),
    routeUsers() {
      this.$router.push("/dashboard/onBoardings");
    },
       redirectImagePath(endpoint){
      window.location.href=endpoint;
    },
    onBoardingUpdate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        console.log("onboarding",this.onBoardingData);
        this.updateOnBoarding(this.onBoardingData).then(response=>{
          console.log(response)
          if(response.processStatus == "Success") {
            this.$router.push('/dashboard/onBoardings');
          }
        });
      }else{
          var errors=[];
          var x = document.getElementsByClassName("v-messages__message");
          for (var i = 0; i < x.length; i++)
              errors.push(x[i].innerHTML);

          this.errorList=errors;

          this.dialog=true;
      }
    },
    previewFiles(){
      console.log("img",this.onBoardingData.img);
      if(this.onBoardingData.img == undefined) {
        this.onBoardingData.imgUrl = '';
      }
      else {
      const file = this.onBoardingData.img;
      this.onBoardingData.imgUrl = URL.createObjectURL(file);
      }
    },
  },
  data: () => ({
    titleValid:true,
    descriptionValid:true,
    alert:false,
    titleErrorMessage:"",
    descriptionErrorMessage:"",
    dialog: false,
    file:[],
    title: "",
    message: "",
    isVisible: false,
    managerName: "",
    valid: true,
    titleRules: [v => !!v || "Başlık alanı zorunludur.",
                 v=>v.trim().length>0 || "Başlık alanı zorunludur.",
                 v => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',]
                 ,
    // fileRules: [
    //   // value => value.size < 1000 || 'Avatar size should be less than 2 MB!',
    //   v => !!v || "Dosya gereklidir.",
    //   v => (v && v.name != null) || "Dosya gereklidir."
    // ],
    descriptionRules: [v => !!v || "Açıklama alanı zorunludur.",
                       v=>v.trim().length>0 || "Açıklama alanı zorunludur.",
                       v => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.'],
    // linkRules: [v => !!v || "Link alanı zorunludur."],
    orderRules: [
      //   v => !!v || "Sıralama alanı zorunludur.",
      v => parseFloat(v) > -1 || "Sıralama 0'dan küçük olmamalıdır."
    ],
      errorList:[]
  }),
  created() {
    let id = this.$route.params.id;
    this.getOnBoarding(id);
  }
};
</script>
